var _path, _circle, _ellipse, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _path2, _path3, _path4, _circle3, _path5, _path6, _g2, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 310,
    viewBox: "0 0 454 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 174.613C-6.0574e-05 201.869 22.8556 266.961 72.2953 295.592C122.777 324.825 165.101 300.365 224.632 301.33C269.596 302.058 297.305 314.988 339.788 301.33C399.898 282.004 465.116 248.87 451.329 191.349C441.741 151.347 396.081 151.996 367.673 120.579C339.335 89.2384 342.374 56.8818 307.255 32.1166C231.235 -21.4914 138.522 18.6758 67.6478 78.0215C31.6352 108.176 6.05743e-05 147.357 0 174.613Z",
    fill: "#EF476F",
    fillOpacity: 0.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 238.212,
    cy: 83.9353,
    r: 50.9353,
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.8922,
    cy: 82.2802,
    rx: 84.8922,
    ry: 82.2802,
    transform: "matrix(-1 0 0 1 210.784 112.668)",
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.795,
    cy: 207.356,
    r: 34.6099,
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.274,
    y: 69.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 137.274 69.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 330.274,
    y: 123.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 330.274 123.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161.274,
    y: 285.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 161.274 285.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 405.274,
    y: 240.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 405.274 240.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.333,
    y: 58,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 139.333 58)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 332.333,
    y: 112,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 332.333 112)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163.333,
    y: 274,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 163.333 274)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 407.333,
    y: 229,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 407.333 229)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283 102L303 103L282 82L283 102Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 87C115 91.9706 110.971 96 106 96C104.197 96 102.518 95.4699 101.11 94.5571L113.557 82.1103C114.47 83.5182 115 85.1972 115 87ZM98.5712 92.0822L111.082 79.5712C109.636 78.58 107.886 78 106 78C101.029 78 97 82.0294 97 87C97 88.8857 97.58 90.636 98.5712 92.0822ZM119 87C119 94.1797 113.18 100 106 100C98.8203 100 93 94.1797 93 87C93 79.8203 98.8203 74 106 74C113.18 74 119 79.8203 119 87Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339 268C339 272.971 334.971 277 330 277C328.197 277 326.518 276.47 325.11 275.557L337.557 263.11C338.47 264.518 339 266.197 339 268ZM322.571 273.082L335.082 260.571C333.636 259.58 331.886 259 330 259C325.029 259 321 263.029 321 268C321 269.886 321.58 271.636 322.571 273.082ZM343 268C343 275.18 337.18 281 330 281C322.82 281 317 275.18 317 268C317 260.82 322.82 255 330 255C337.18 255 343 260.82 343 268Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.342 69.2614C298.169 68.6257 298.648 68 299.307 68H309.693C310.352 68 310.831 68.6257 310.658 69.2614L305.465 88.4361C305.199 89.4209 303.801 89.4209 303.535 88.4361L298.342 69.2614Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.5,
    cy: 96.5,
    r: 3.5,
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.483 103C127.491 85.6666 152.509 85.6667 162.517 103L217.076 197.5C227.084 214.833 214.574 236.5 194.56 236.5H85.4404C65.4255 236.5 52.9163 214.833 62.9237 197.5L117.483 103Z",
    fill: "#EF476F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.668 110.686C135.517 104.019 145.14 104.019 148.989 110.686L204.105 206.15C207.954 212.817 203.143 221.15 195.445 221.15H85.212C77.5141 221.15 72.7028 212.817 76.5518 206.15L131.668 110.686Z",
    stroke: "white",
    strokeWidth: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.469 132.532C148.936 132.532 155.21 140.397 153.329 148.652L146.753 177.516C146.085 180.449 143.477 182.529 140.469 182.529C137.462 182.529 134.854 180.449 134.186 177.516L127.61 148.652C125.729 140.397 132.003 132.532 140.469 132.532Z",
    fill: "white"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 198,
    r: 8,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4df7f978623e99664980c26b0d1d9cd8.svg";
export { ForwardRef as ReactComponent };